import React, { FunctionComponent, useState, useEffect } from 'react'
import Inputs, { InputsGroup, InputLabel, InputImage } from '../../Components/Inputs'
import { getCatalogs } from 'actions/catalogs';
import { getViews } from 'actions/vista';

type FormVistaProps = {
    item: any
    action: string
    errors: any
    viewsParent: any
    handleOnChange: (e: any) => void
}

const FormVista: FunctionComponent<FormVistaProps> = ({ item, action, errors, viewsParent, handleOnChange }) => {

    const [viewTypes, setViewTypes] = React.useState([]);
    const [status, setStatus] = useState([])

    useEffect(() => {
        handleViewTypes()
        handleStatus()
    }, [])

    const handleViewTypes = () => {
        getCatalogs("segVistaTbl", "idTipoVista").then((res) => {
            if (res) {
                res = res.filter((item: any) => (item.valor < 4))

                res.unshift({
                    valor: 0,
                    descripcion: "Seleccionar"
                })

                setViewTypes(res.map((e: any) => {
                    return {
                        value: e.valor,
                        text: e.descripcion
                    }
                }))
            }
        })
    }

    const handleStatus = () => {
        const statusList: any = [{ value: 1, text: "Activo" }, { value: 0, text: "Inactivo" }]
        setStatus(statusList)
    }

    const renderInputs = () => {
        return (
            <>
                <InputsGroup>
                    <>
                        <Inputs
                            id={"codigoVista"}
                            label={"Código"}
                            type={"text"}
                            value={item?.codigoVista}
                            handleOnChange={handleOnChange}
                            className={`input ${errors["codigoVista"] ? "input_error" : ""}`}
                            errorMessage={errors["codigoVista"]}
                        />
                        <Inputs
                            id={"descripcionMenu"}
                            label={"Descripción Menu"}
                            type={"text"}
                            value={item?.descripcionMenu}
                            handleOnChange={handleOnChange}
                            className={`input ${errors["descripcionMenu"] ? "input_error" : ""}`}
                            errorMessage={errors["descripcionMenu"]}
                        />
                    </>
                </InputsGroup>
                <InputsGroup>
                    <>
                        <Inputs
                            id={"descripcion"}
                            label={"Descripción"}
                            type={"text"}
                            value={item?.descripcion}
                            handleOnChange={handleOnChange}
                            className={`input ${errors["descripcion"] ? "input_error" : ""}`}
                            errorMessage={errors["descripcion"]}
                        />
                        <Inputs
                            id={"idTipoVista"}
                            label={"Tipo Vista"}
                            type={"select"}
                            value={item?.idTipoVista}
                            handleOnChange={handleOnChange}
                            options={viewTypes}
                            className={`input ${errors["idTipoVista"] ? "input_error" : ""}`}
                            errorMessage={errors["idTipoVista"]}
                        />
                    </>
                </InputsGroup>
                <InputsGroup>
                    <>
                        <Inputs
                            id={"url"}
                            label={"URL"}
                            type={"text"}
                            value={item?.url}
                            labelPercent={12}
                            handleOnChange={handleOnChange}
                            className={`input ${errors["url"] ? "input_error" : ""}`}
                            errorMessage={errors["url"]}
                        />
                    </>
                </InputsGroup>
                <InputsGroup>
                    <>
                        <Inputs
                            id={"imagen"}
                            label={"Imagen"}
                            type={"file"}
                            value={item?.imagen}
                            accept={".jpeg,.jpg,.png"}
                            labelPercent={13}
                            handleOnChange={handleOnChange}
                            className={`input ${errors["image"] ? "input_error" : ""}`}
                            errorMessage={errors["image"]}
                        />
                    </>
                </InputsGroup>
                <InputsGroup>
                    <>
                        <Inputs
                            id={"idVistaPadre"}
                            label={"Vista Padre"}
                            type={"select"}
                            value={item?.idVistaPadre}
                            handleOnChange={handleOnChange}
                            options={viewsParent}
                            className={`input ${errors["idVistaPadre"] ? "input_error" : ""}`}
                            errorMessage={errors["idVistaPadre"]}
                        />
                        <Inputs
                            id={"idEstatus"}
                            label={"Estatus"}
                            type={"select"}
                            value={item?.idEstatus}
                            handleOnChange={handleOnChange}
                            options={status}
                            className={`input ${errors["idEstatus"] ? "input_error" : ""}`}
                            errorMessage={errors["idEstatus"]}
                        />
                    </>
                </InputsGroup>
            </>
        )
    }

    return (
        <>
            {renderInputs()}
        </>
    )
}

export default FormVista